import React, { useRef } from 'react';

import ModalDirectors from './ModalDirectors';

import BernardoBg from '../../../../../Images/modals/directors/bernardo/bg_bernardo.png';
import Video1 from '../../../../../Images/modals/directors/bernardo/video-1.png';
import Video2 from '../../../../../Images/modals/directors/bernardo/video-2.png';
import Video3 from '../../../../../Images/modals/directors/bernardo/video-3.png';
import Video4 from '../../../../../Images/modals/directors/bernardo/video-4.png';

import {
  Director_Bernardo,
  Text_Bernardo,
  TextVideo1_Bernardo,
  TextVideo2_Bernardo,
  TextVideo3_Bernardo,
  TextVideo4_Bernardo,
} from '../../../../../utils/ES/Modals/directors';

const ModalBernardo = () => {
  return (
    <>
      <ModalDirectors
        id="director-bernardo"
        mainBg={BernardoBg}
        directorName={Director_Bernardo}
        mainVideoBg={Video1}
        videoText1={TextVideo1_Bernardo}
        mainVideoLink={'bernardo-video-1'}
        directorText={Text_Bernardo}
        rowImage1={Video2}
        videoText2={TextVideo2_Bernardo}
        rowVideoLink1={'bernardo-video-2'}
        rowImage2={Video3}
        videoText3={TextVideo3_Bernardo}
        rowVideoLink2={'bernardo-video-3'}
        rowImage3={Video4}
        videoText4={TextVideo4_Bernardo}
        rowVideoLink3={'bernardo-video-4'}
      />
    </>
  );
};

export default ModalBernardo;
